import { useBlockProps } from '@wordpress/block-editor';
import { RichText } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import { FC } from 'react';

interface EditProps {
  attributes: {
    label?: string;
  };
  setAttributes: (attributes: Record<string, any>) => void;
}

const Edit: FC<EditProps> = ({ attributes: {label}, setAttributes }) => {
  return (
      <button {...useBlockProps()}>
        <RichText
          value={label}
          placeholder={__('Menu', 'neodigital')}
          keepplaceholderonfocus="true"
          onChange={(label) => setAttributes({label})}
        />
      </button>
  );
};

export default Edit;
